import { Menu, PanelLeftClose } from 'lucide-react';

import { SidebarNav } from './sidebar-nav.jsx';
import { TeamScopeSelect } from './team-scope-select.jsx';

import cirunLogo from '@/assets/cirun-logo-inverted.svg';
import { ThemeToggle } from '@/components/common/theme-toggle.jsx';
import { Button } from '@/components/ui/button.jsx';
import { Sheet, SheetContent, SheetTitle, SheetTrigger } from '@/components/ui/sheet.jsx';
import { ROUTES } from '@/config/routes.js';


export function Topbar({ userMenuSlot, onToggleSidebar }) {
  return (
    <header className="sticky top-0 z-30 flex h-14 items-center gap-3 border-b border-border bg-background px-4">
      {/* Mobile: open a sheet with the full nav */}
      <Sheet>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className="lg:hidden"
            aria-label="Open navigation"
          >
            <Menu className="h-5 w-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-72 p-0">
          <SheetTitle className="sr-only">Navigation</SheetTitle>
          <SidebarNav />
        </SheetContent>
      </Sheet>
      {/* Desktop: collapse/expand the always-visible sidebar */}
      {onToggleSidebar && (
        <Button
          variant="ghost"
          size="icon"
          className="hidden lg:inline-flex"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <PanelLeftClose className="h-5 w-5" />
        </Button>
      )}
      <a href={ROUTES.ROOT} aria-label="cirun" className="lg:hidden">
        <img src={cirunLogo} alt="cirun" className="h-7 w-auto" />
      </a>
      <div className="flex-1" />
      <TeamScopeSelect />
      <ThemeToggle />
      {userMenuSlot}
    </header>
  );
}
